// Single source of truth for the LiveKit egress recording route prefix.
// `layout.tsx`, `providers.tsx` and the pre-boot beacon all gate behavior on this -
// keep them aligned here.
export const EGRESS_ROUTE_PREFIX = '/lk-recording/';

export const isEgressRoute = (pathname: string | null | undefined): boolean =>
  pathname?.startsWith(EGRESS_ROUTE_PREFIX) ?? false;

// The window property that tells the pre-boot watchdog that the egress layout
// chunk ran.
export const EGRESS_BOOTED_FLAG = '__askableEgressBooted';

// The window property that the pre-boot beacon sets when its inline script runs.
export const EGRESS_BEACON_RAN_FLAG = '__askableEgressBeaconRan' satisfies keyof Window;

export const markEgressBooted = () => {
  Reflect.set(window, EGRESS_BOOTED_FLAG, true);
};
